/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as BusinessSignupRouteImport } from './routes/business-signup'
import { Route as BusinessTypeRouteImport } from './routes/business-type'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as EventsRouteImport } from './routes/events'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as CategoriesEventCentresRouteImport } from './routes/_categories/event-centres'
import { Route as CategoriesHotelsRouteImport } from './routes/_categories/hotels'
import { Route as CategoriesOpenSpacesRouteImport } from './routes/_categories/open-spaces'
import { Route as HostListYourPropertyRouteImport } from './routes/_host/list-your-property'
import { Route as HostMyVenuesRouteImport } from './routes/_host/my-venues'
import { Route as InfoAboutRouteImport } from './routes/_info/about'
import { Route as InfoContactRouteImport } from './routes/_info/contact'
import { Route as UserBookingsRouteImport } from './routes/_user/bookings'
import { Route as UserProfileRouteImport } from './routes/_user/profile'
import { Route as UserWalletRouteImport } from './routes/_user/wallet'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as AdminBookingsRouteImport } from './routes/admin/bookings'
import { Route as AdminCalendarRouteImport } from './routes/admin/calendar'
import { Route as AdminCheckInRouteImport } from './routes/admin/check-in'
import { Route as AdminCustomersRouteImport } from './routes/admin/customers'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminEarningsRouteImport } from './routes/admin/earnings'
import { Route as AdminEscrowsRouteImport } from './routes/admin/escrows'
import { Route as AdminEventsRouteImport } from './routes/admin/events'
import { Route as AdminListingsRouteImport } from './routes/admin/listings'
import { Route as AdminManagerAnalyticsRouteImport } from './routes/admin/manager-analytics'
import { Route as AdminModeratorRouteImport } from './routes/admin/moderator'
import { Route as AdminMyBookingsRouteImport } from './routes/admin/my-bookings'
import { Route as AdminPendingPayoutsRouteImport } from './routes/admin/pending-payouts'
import { Route as AdminProfileRouteImport } from './routes/admin/profile'
import { Route as AdminRefundsRouteImport } from './routes/admin/refunds'
import { Route as AdminReviewsRouteImport } from './routes/admin/reviews'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminRoomsRouteImport } from './routes/admin/rooms'
import { Route as AdminScanTicketsRouteImport } from './routes/admin/scan-tickets'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminStaffRouteImport } from './routes/admin/staff'
import { Route as AdminSupportRouteImport } from './routes/admin/support'
import { Route as AdminVenueManagersRouteImport } from './routes/admin/venue-managers'
import { Route as AdminVenuesRouteImport } from './routes/admin/venues'
import { Route as AdminWalletRouteImport } from './routes/admin/wallet'
import { Route as AdminWithdrawalsRouteImport } from './routes/admin/withdrawals'
import { Route as BookingVenueIdRouteImport } from './routes/booking/$venueId'
import { Route as BookingSuccessRouteImport } from './routes/booking/success'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardBookingsRouteImport } from './routes/dashboard/bookings'
import { Route as DashboardProfileRouteImport } from './routes/dashboard/profile'
import { Route as DashboardWalletRouteImport } from './routes/dashboard/wallet'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as EventsEventIdRouteImport } from './routes/events.$eventId'
import { Route as EventsCreateRouteImport } from './routes/events.create'
import { Route as VenuesVenueIdRouteImport } from './routes/venues/$venueId'
import { Route as UserBookingsIdRouteImport } from './routes/_user/bookings.$id'
import { Route as AdminBookingsIdRouteImport } from './routes/admin/bookings.$id'
import { Route as EventsEventIdTicketsRouteImport } from './routes/events.$eventId.tickets'
import { Route as RoomDetailVenueIdRoomIdRouteImport } from './routes/room-detail.$venueId.$roomId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessSignupRoute = BusinessSignupRouteImport.update({
  id: '/business-signup',
  path: '/business-signup',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessTypeRoute = BusinessTypeRouteImport.update({
  id: '/business-type',
  path: '/business-type',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/_auth/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/_auth/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/_auth/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesEventCentresRoute = CategoriesEventCentresRouteImport.update({
  id: '/_categories/event-centres',
  path: '/event-centres',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesHotelsRoute = CategoriesHotelsRouteImport.update({
  id: '/_categories/hotels',
  path: '/hotels',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesOpenSpacesRoute = CategoriesOpenSpacesRouteImport.update({
  id: '/_categories/open-spaces',
  path: '/open-spaces',
  getParentRoute: () => rootRouteImport,
} as any)
const HostListYourPropertyRoute = HostListYourPropertyRouteImport.update({
  id: '/_host/list-your-property',
  path: '/list-your-property',
  getParentRoute: () => rootRouteImport,
} as any)
const HostMyVenuesRoute = HostMyVenuesRouteImport.update({
  id: '/_host/my-venues',
  path: '/my-venues',
  getParentRoute: () => rootRouteImport,
} as any)
const InfoAboutRoute = InfoAboutRouteImport.update({
  id: '/_info/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const InfoContactRoute = InfoContactRouteImport.update({
  id: '/_info/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const UserBookingsRoute = UserBookingsRouteImport.update({
  id: '/_user/bookings',
  path: '/bookings',
  getParentRoute: () => rootRouteImport,
} as any)
const UserProfileRoute = UserProfileRouteImport.update({
  id: '/_user/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const UserWalletRoute = UserWalletRouteImport.update({
  id: '/_user/wallet',
  path: '/wallet',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBookingsRoute = AdminBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCalendarRoute = AdminCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCheckInRoute = AdminCheckInRouteImport.update({
  id: '/check-in',
  path: '/check-in',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomersRoute = AdminCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEarningsRoute = AdminEarningsRouteImport.update({
  id: '/earnings',
  path: '/earnings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEscrowsRoute = AdminEscrowsRouteImport.update({
  id: '/escrows',
  path: '/escrows',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEventsRoute = AdminEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AdminRoute,
} as any)
const AdminListingsRoute = AdminListingsRouteImport.update({
  id: '/listings',
  path: '/listings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminManagerAnalyticsRoute = AdminManagerAnalyticsRouteImport.update({
  id: '/manager-analytics',
  path: '/manager-analytics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminModeratorRoute = AdminModeratorRouteImport.update({
  id: '/moderator',
  path: '/moderator',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMyBookingsRoute = AdminMyBookingsRouteImport.update({
  id: '/my-bookings',
  path: '/my-bookings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPendingPayoutsRoute = AdminPendingPayoutsRouteImport.update({
  id: '/pending-payouts',
  path: '/pending-payouts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProfileRoute = AdminProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRefundsRoute = AdminRefundsRouteImport.update({
  id: '/refunds',
  path: '/refunds',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReviewsRoute = AdminReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRoomsRoute = AdminRoomsRouteImport.update({
  id: '/rooms',
  path: '/rooms',
  getParentRoute: () => AdminRoute,
} as any)
const AdminScanTicketsRoute = AdminScanTicketsRouteImport.update({
  id: '/scan-tickets',
  path: '/scan-tickets',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStaffRoute = AdminStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSupportRoute = AdminSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVenueManagersRoute = AdminVenueManagersRouteImport.update({
  id: '/venue-managers',
  path: '/venue-managers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVenuesRoute = AdminVenuesRouteImport.update({
  id: '/venues',
  path: '/venues',
  getParentRoute: () => AdminRoute,
} as any)
const AdminWalletRoute = AdminWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => AdminRoute,
} as any)
const AdminWithdrawalsRoute = AdminWithdrawalsRouteImport.update({
  id: '/withdrawals',
  path: '/withdrawals',
  getParentRoute: () => AdminRoute,
} as any)
const BookingVenueIdRoute = BookingVenueIdRouteImport.update({
  id: '/booking/$venueId',
  path: '/booking/$venueId',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingSuccessRoute = BookingSuccessRouteImport.update({
  id: '/booking/success',
  path: '/booking/success',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBookingsRoute = DashboardBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardWalletRoute = DashboardWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => DashboardRoute,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EventsRoute,
} as any)
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/$eventId',
  path: '/$eventId',
  getParentRoute: () => EventsRoute,
} as any)
const EventsCreateRoute = EventsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => EventsRoute,
} as any)
const VenuesVenueIdRoute = VenuesVenueIdRouteImport.update({
  id: '/venues/$venueId',
  path: '/venues/$venueId',
  getParentRoute: () => rootRouteImport,
} as any)
const UserBookingsIdRoute = UserBookingsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => UserBookingsRoute,
} as any)
const AdminBookingsIdRoute = AdminBookingsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminBookingsRoute,
} as any)
const EventsEventIdTicketsRoute = EventsEventIdTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => EventsEventIdRoute,
} as any)
const RoomDetailVenueIdRoomIdRoute = RoomDetailVenueIdRoomIdRouteImport.update({
  id: '/room-detail/$venueId/$roomId',
  path: '/room-detail/$venueId/$roomId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/business-signup': typeof BusinessSignupRoute
  '/business-type': typeof BusinessTypeRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/events': typeof EventsRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
  '/event-centres': typeof CategoriesEventCentresRoute
  '/hotels': typeof CategoriesHotelsRoute
  '/open-spaces': typeof CategoriesOpenSpacesRoute
  '/list-your-property': typeof HostListYourPropertyRoute
  '/my-venues': typeof HostMyVenuesRoute
  '/about': typeof InfoAboutRoute
  '/contact': typeof InfoContactRoute
  '/bookings': typeof UserBookingsRouteWithChildren
  '/profile': typeof UserProfileRoute
  '/wallet': typeof UserWalletRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/bookings': typeof AdminBookingsRouteWithChildren
  '/admin/calendar': typeof AdminCalendarRoute
  '/admin/check-in': typeof AdminCheckInRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/earnings': typeof AdminEarningsRoute
  '/admin/escrows': typeof AdminEscrowsRoute
  '/admin/events': typeof AdminEventsRoute
  '/admin/listings': typeof AdminListingsRoute
  '/admin/manager-analytics': typeof AdminManagerAnalyticsRoute
  '/admin/moderator': typeof AdminModeratorRoute
  '/admin/my-bookings': typeof AdminMyBookingsRoute
  '/admin/pending-payouts': typeof AdminPendingPayoutsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/refunds': typeof AdminRefundsRoute
  '/admin/reviews': typeof AdminReviewsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/rooms': typeof AdminRoomsRoute
  '/admin/scan-tickets': typeof AdminScanTicketsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/venue-managers': typeof AdminVenueManagersRoute
  '/admin/venues': typeof AdminVenuesRoute
  '/admin/wallet': typeof AdminWalletRoute
  '/admin/withdrawals': typeof AdminWithdrawalsRoute
  '/booking/$venueId': typeof BookingVenueIdRoute
  '/booking/success': typeof BookingSuccessRoute
  '/dashboard/bookings': typeof DashboardBookingsRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/wallet': typeof DashboardWalletRoute
  '/events/$eventId': typeof EventsEventIdRouteWithChildren
  '/events/create': typeof EventsCreateRoute
  '/venues/$venueId': typeof VenuesVenueIdRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/events/': typeof EventsIndexRoute
  '/bookings/$id': typeof UserBookingsIdRoute
  '/admin/bookings/$id': typeof AdminBookingsIdRoute
  '/events/$eventId/tickets': typeof EventsEventIdTicketsRoute
  '/room-detail/$venueId/$roomId': typeof RoomDetailVenueIdRoomIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/business-signup': typeof BusinessSignupRoute
  '/business-type': typeof BusinessTypeRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
  '/event-centres': typeof CategoriesEventCentresRoute
  '/hotels': typeof CategoriesHotelsRoute
  '/open-spaces': typeof CategoriesOpenSpacesRoute
  '/list-your-property': typeof HostListYourPropertyRoute
  '/my-venues': typeof HostMyVenuesRoute
  '/about': typeof InfoAboutRoute
  '/contact': typeof InfoContactRoute
  '/bookings': typeof UserBookingsRouteWithChildren
  '/profile': typeof UserProfileRoute
  '/wallet': typeof UserWalletRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/bookings': typeof AdminBookingsRouteWithChildren
  '/admin/calendar': typeof AdminCalendarRoute
  '/admin/check-in': typeof AdminCheckInRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/earnings': typeof AdminEarningsRoute
  '/admin/escrows': typeof AdminEscrowsRoute
  '/admin/events': typeof AdminEventsRoute
  '/admin/listings': typeof AdminListingsRoute
  '/admin/manager-analytics': typeof AdminManagerAnalyticsRoute
  '/admin/moderator': typeof AdminModeratorRoute
  '/admin/my-bookings': typeof AdminMyBookingsRoute
  '/admin/pending-payouts': typeof AdminPendingPayoutsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/refunds': typeof AdminRefundsRoute
  '/admin/reviews': typeof AdminReviewsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/rooms': typeof AdminRoomsRoute
  '/admin/scan-tickets': typeof AdminScanTicketsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/venue-managers': typeof AdminVenueManagersRoute
  '/admin/venues': typeof AdminVenuesRoute
  '/admin/wallet': typeof AdminWalletRoute
  '/admin/withdrawals': typeof AdminWithdrawalsRoute
  '/booking/$venueId': typeof BookingVenueIdRoute
  '/booking/success': typeof BookingSuccessRoute
  '/dashboard/bookings': typeof DashboardBookingsRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/wallet': typeof DashboardWalletRoute
  '/events/$eventId': typeof EventsEventIdRouteWithChildren
  '/events/create': typeof EventsCreateRoute
  '/venues/$venueId': typeof VenuesVenueIdRoute
  '/admin': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/events': typeof EventsIndexRoute
  '/bookings/$id': typeof UserBookingsIdRoute
  '/admin/bookings/$id': typeof AdminBookingsIdRoute
  '/events/$eventId/tickets': typeof EventsEventIdTicketsRoute
  '/room-detail/$venueId/$roomId': typeof RoomDetailVenueIdRoomIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/business-signup': typeof BusinessSignupRoute
  '/business-type': typeof BusinessTypeRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/events': typeof EventsRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_categories/event-centres': typeof CategoriesEventCentresRoute
  '/_categories/hotels': typeof CategoriesHotelsRoute
  '/_categories/open-spaces': typeof CategoriesOpenSpacesRoute
  '/_host/list-your-property': typeof HostListYourPropertyRoute
  '/_host/my-venues': typeof HostMyVenuesRoute
  '/_info/about': typeof InfoAboutRoute
  '/_info/contact': typeof InfoContactRoute
  '/_user/bookings': typeof UserBookingsRouteWithChildren
  '/_user/profile': typeof UserProfileRoute
  '/_user/wallet': typeof UserWalletRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/bookings': typeof AdminBookingsRouteWithChildren
  '/admin/calendar': typeof AdminCalendarRoute
  '/admin/check-in': typeof AdminCheckInRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/earnings': typeof AdminEarningsRoute
  '/admin/escrows': typeof AdminEscrowsRoute
  '/admin/events': typeof AdminEventsRoute
  '/admin/listings': typeof AdminListingsRoute
  '/admin/manager-analytics': typeof AdminManagerAnalyticsRoute
  '/admin/moderator': typeof AdminModeratorRoute
  '/admin/my-bookings': typeof AdminMyBookingsRoute
  '/admin/pending-payouts': typeof AdminPendingPayoutsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/refunds': typeof AdminRefundsRoute
  '/admin/reviews': typeof AdminReviewsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/rooms': typeof AdminRoomsRoute
  '/admin/scan-tickets': typeof AdminScanTicketsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/venue-managers': typeof AdminVenueManagersRoute
  '/admin/venues': typeof AdminVenuesRoute
  '/admin/wallet': typeof AdminWalletRoute
  '/admin/withdrawals': typeof AdminWithdrawalsRoute
  '/booking/$venueId': typeof BookingVenueIdRoute
  '/booking/success': typeof BookingSuccessRoute
  '/dashboard/bookings': typeof DashboardBookingsRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/wallet': typeof DashboardWalletRoute
  '/events/$eventId': typeof EventsEventIdRouteWithChildren
  '/events/create': typeof EventsCreateRoute
  '/venues/$venueId': typeof VenuesVenueIdRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/events/': typeof EventsIndexRoute
  '/_user/bookings/$id': typeof UserBookingsIdRoute
  '/admin/bookings/$id': typeof AdminBookingsIdRoute
  '/events/$eventId/tickets': typeof EventsEventIdTicketsRoute
  '/room-detail/$venueId/$roomId': typeof RoomDetailVenueIdRoomIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/business-signup'
    | '/business-type'
    | '/dashboard'
    | '/events'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/event-centres'
    | '/hotels'
    | '/open-spaces'
    | '/list-your-property'
    | '/my-venues'
    | '/about'
    | '/contact'
    | '/bookings'
    | '/profile'
    | '/wallet'
    | '/admin/analytics'
    | '/admin/bookings'
    | '/admin/calendar'
    | '/admin/check-in'
    | '/admin/customers'
    | '/admin/dashboard'
    | '/admin/earnings'
    | '/admin/escrows'
    | '/admin/events'
    | '/admin/listings'
    | '/admin/manager-analytics'
    | '/admin/moderator'
    | '/admin/my-bookings'
    | '/admin/pending-payouts'
    | '/admin/profile'
    | '/admin/refunds'
    | '/admin/reviews'
    | '/admin/roles'
    | '/admin/rooms'
    | '/admin/scan-tickets'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/support'
    | '/admin/venue-managers'
    | '/admin/venues'
    | '/admin/wallet'
    | '/admin/withdrawals'
    | '/booking/$venueId'
    | '/booking/success'
    | '/dashboard/bookings'
    | '/dashboard/profile'
    | '/dashboard/wallet'
    | '/events/$eventId'
    | '/events/create'
    | '/venues/$venueId'
    | '/admin/'
    | '/dashboard/'
    | '/events/'
    | '/bookings/$id'
    | '/admin/bookings/$id'
    | '/events/$eventId/tickets'
    | '/room-detail/$venueId/$roomId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/business-signup'
    | '/business-type'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/event-centres'
    | '/hotels'
    | '/open-spaces'
    | '/list-your-property'
    | '/my-venues'
    | '/about'
    | '/contact'
    | '/bookings'
    | '/profile'
    | '/wallet'
    | '/admin/analytics'
    | '/admin/bookings'
    | '/admin/calendar'
    | '/admin/check-in'
    | '/admin/customers'
    | '/admin/dashboard'
    | '/admin/earnings'
    | '/admin/escrows'
    | '/admin/events'
    | '/admin/listings'
    | '/admin/manager-analytics'
    | '/admin/moderator'
    | '/admin/my-bookings'
    | '/admin/pending-payouts'
    | '/admin/profile'
    | '/admin/refunds'
    | '/admin/reviews'
    | '/admin/roles'
    | '/admin/rooms'
    | '/admin/scan-tickets'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/support'
    | '/admin/venue-managers'
    | '/admin/venues'
    | '/admin/wallet'
    | '/admin/withdrawals'
    | '/booking/$venueId'
    | '/booking/success'
    | '/dashboard/bookings'
    | '/dashboard/profile'
    | '/dashboard/wallet'
    | '/events/$eventId'
    | '/events/create'
    | '/venues/$venueId'
    | '/admin'
    | '/dashboard'
    | '/events'
    | '/bookings/$id'
    | '/admin/bookings/$id'
    | '/events/$eventId/tickets'
    | '/room-detail/$venueId/$roomId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/business-signup'
    | '/business-type'
    | '/dashboard'
    | '/events'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/signup'
    | '/_categories/event-centres'
    | '/_categories/hotels'
    | '/_categories/open-spaces'
    | '/_host/list-your-property'
    | '/_host/my-venues'
    | '/_info/about'
    | '/_info/contact'
    | '/_user/bookings'
    | '/_user/profile'
    | '/_user/wallet'
    | '/admin/analytics'
    | '/admin/bookings'
    | '/admin/calendar'
    | '/admin/check-in'
    | '/admin/customers'
    | '/admin/dashboard'
    | '/admin/earnings'
    | '/admin/escrows'
    | '/admin/events'
    | '/admin/listings'
    | '/admin/manager-analytics'
    | '/admin/moderator'
    | '/admin/my-bookings'
    | '/admin/pending-payouts'
    | '/admin/profile'
    | '/admin/refunds'
    | '/admin/reviews'
    | '/admin/roles'
    | '/admin/rooms'
    | '/admin/scan-tickets'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/support'
    | '/admin/venue-managers'
    | '/admin/venues'
    | '/admin/wallet'
    | '/admin/withdrawals'
    | '/booking/$venueId'
    | '/booking/success'
    | '/dashboard/bookings'
    | '/dashboard/profile'
    | '/dashboard/wallet'
    | '/events/$eventId'
    | '/events/create'
    | '/venues/$venueId'
    | '/admin/'
    | '/dashboard/'
    | '/events/'
    | '/_user/bookings/$id'
    | '/admin/bookings/$id'
    | '/events/$eventId/tickets'
    | '/room-detail/$venueId/$roomId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  BusinessSignupRoute: typeof BusinessSignupRoute
  BusinessTypeRoute: typeof BusinessTypeRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  EventsRoute: typeof EventsRouteWithChildren
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSignupRoute: typeof AuthSignupRoute
  CategoriesEventCentresRoute: typeof CategoriesEventCentresRoute
  CategoriesHotelsRoute: typeof CategoriesHotelsRoute
  CategoriesOpenSpacesRoute: typeof CategoriesOpenSpacesRoute
  HostListYourPropertyRoute: typeof HostListYourPropertyRoute
  HostMyVenuesRoute: typeof HostMyVenuesRoute
  InfoAboutRoute: typeof InfoAboutRoute
  InfoContactRoute: typeof InfoContactRoute
  UserBookingsRoute: typeof UserBookingsRouteWithChildren
  UserProfileRoute: typeof UserProfileRoute
  UserWalletRoute: typeof UserWalletRoute
  BookingVenueIdRoute: typeof BookingVenueIdRoute
  BookingSuccessRoute: typeof BookingSuccessRoute
  VenuesVenueIdRoute: typeof VenuesVenueIdRoute
  RoomDetailVenueIdRoomIdRoute: typeof RoomDetailVenueIdRoomIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-signup': {
      id: '/business-signup'
      path: '/business-signup'
      fullPath: '/business-signup'
      preLoaderRoute: typeof BusinessSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-type': {
      id: '/business-type'
      path: '/business-type'
      fullPath: '/business-type'
      preLoaderRoute: typeof BusinessTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_categories/event-centres': {
      id: '/_categories/event-centres'
      path: '/event-centres'
      fullPath: '/event-centres'
      preLoaderRoute: typeof CategoriesEventCentresRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_categories/hotels': {
      id: '/_categories/hotels'
      path: '/hotels'
      fullPath: '/hotels'
      preLoaderRoute: typeof CategoriesHotelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_categories/open-spaces': {
      id: '/_categories/open-spaces'
      path: '/open-spaces'
      fullPath: '/open-spaces'
      preLoaderRoute: typeof CategoriesOpenSpacesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_host/list-your-property': {
      id: '/_host/list-your-property'
      path: '/list-your-property'
      fullPath: '/list-your-property'
      preLoaderRoute: typeof HostListYourPropertyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_host/my-venues': {
      id: '/_host/my-venues'
      path: '/my-venues'
      fullPath: '/my-venues'
      preLoaderRoute: typeof HostMyVenuesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_info/about': {
      id: '/_info/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof InfoAboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_info/contact': {
      id: '/_info/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof InfoContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_user/bookings': {
      id: '/_user/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof UserBookingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_user/profile': {
      id: '/_user/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof UserProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_user/wallet': {
      id: '/_user/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof UserWalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/bookings': {
      id: '/admin/bookings'
      path: '/bookings'
      fullPath: '/admin/bookings'
      preLoaderRoute: typeof AdminBookingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/calendar': {
      id: '/admin/calendar'
      path: '/calendar'
      fullPath: '/admin/calendar'
      preLoaderRoute: typeof AdminCalendarRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/check-in': {
      id: '/admin/check-in'
      path: '/check-in'
      fullPath: '/admin/check-in'
      preLoaderRoute: typeof AdminCheckInRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers': {
      id: '/admin/customers'
      path: '/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AdminCustomersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/earnings': {
      id: '/admin/earnings'
      path: '/earnings'
      fullPath: '/admin/earnings'
      preLoaderRoute: typeof AdminEarningsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/escrows': {
      id: '/admin/escrows'
      path: '/escrows'
      fullPath: '/admin/escrows'
      preLoaderRoute: typeof AdminEscrowsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/events': {
      id: '/admin/events'
      path: '/events'
      fullPath: '/admin/events'
      preLoaderRoute: typeof AdminEventsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/listings': {
      id: '/admin/listings'
      path: '/listings'
      fullPath: '/admin/listings'
      preLoaderRoute: typeof AdminListingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/manager-analytics': {
      id: '/admin/manager-analytics'
      path: '/manager-analytics'
      fullPath: '/admin/manager-analytics'
      preLoaderRoute: typeof AdminManagerAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/moderator': {
      id: '/admin/moderator'
      path: '/moderator'
      fullPath: '/admin/moderator'
      preLoaderRoute: typeof AdminModeratorRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/my-bookings': {
      id: '/admin/my-bookings'
      path: '/my-bookings'
      fullPath: '/admin/my-bookings'
      preLoaderRoute: typeof AdminMyBookingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/pending-payouts': {
      id: '/admin/pending-payouts'
      path: '/pending-payouts'
      fullPath: '/admin/pending-payouts'
      preLoaderRoute: typeof AdminPendingPayoutsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/profile': {
      id: '/admin/profile'
      path: '/profile'
      fullPath: '/admin/profile'
      preLoaderRoute: typeof AdminProfileRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/refunds': {
      id: '/admin/refunds'
      path: '/refunds'
      fullPath: '/admin/refunds'
      preLoaderRoute: typeof AdminRefundsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reviews': {
      id: '/admin/reviews'
      path: '/reviews'
      fullPath: '/admin/reviews'
      preLoaderRoute: typeof AdminReviewsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/rooms': {
      id: '/admin/rooms'
      path: '/rooms'
      fullPath: '/admin/rooms'
      preLoaderRoute: typeof AdminRoomsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/scan-tickets': {
      id: '/admin/scan-tickets'
      path: '/scan-tickets'
      fullPath: '/admin/scan-tickets'
      preLoaderRoute: typeof AdminScanTicketsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/staff': {
      id: '/admin/staff'
      path: '/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AdminStaffRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/support': {
      id: '/admin/support'
      path: '/support'
      fullPath: '/admin/support'
      preLoaderRoute: typeof AdminSupportRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/venue-managers': {
      id: '/admin/venue-managers'
      path: '/venue-managers'
      fullPath: '/admin/venue-managers'
      preLoaderRoute: typeof AdminVenueManagersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/venues': {
      id: '/admin/venues'
      path: '/venues'
      fullPath: '/admin/venues'
      preLoaderRoute: typeof AdminVenuesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/wallet': {
      id: '/admin/wallet'
      path: '/wallet'
      fullPath: '/admin/wallet'
      preLoaderRoute: typeof AdminWalletRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/withdrawals': {
      id: '/admin/withdrawals'
      path: '/withdrawals'
      fullPath: '/admin/withdrawals'
      preLoaderRoute: typeof AdminWithdrawalsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/booking/$venueId': {
      id: '/booking/$venueId'
      path: '/booking/$venueId'
      fullPath: '/booking/$venueId'
      preLoaderRoute: typeof BookingVenueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/success': {
      id: '/booking/success'
      path: '/booking/success'
      fullPath: '/booking/success'
      preLoaderRoute: typeof BookingSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/bookings': {
      id: '/dashboard/bookings'
      path: '/bookings'
      fullPath: '/dashboard/bookings'
      preLoaderRoute: typeof DashboardBookingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/profile': {
      id: '/dashboard/profile'
      path: '/profile'
      fullPath: '/dashboard/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/wallet': {
      id: '/dashboard/wallet'
      path: '/wallet'
      fullPath: '/dashboard/wallet'
      preLoaderRoute: typeof DashboardWalletRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/events/': {
      id: '/events/'
      path: '/'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof EventsRoute
    }
    '/events/$eventId': {
      id: '/events/$eventId'
      path: '/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof EventsEventIdRouteImport
      parentRoute: typeof EventsRoute
    }
    '/events/create': {
      id: '/events/create'
      path: '/create'
      fullPath: '/events/create'
      preLoaderRoute: typeof EventsCreateRouteImport
      parentRoute: typeof EventsRoute
    }
    '/venues/$venueId': {
      id: '/venues/$venueId'
      path: '/venues/$venueId'
      fullPath: '/venues/$venueId'
      preLoaderRoute: typeof VenuesVenueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_user/bookings/$id': {
      id: '/_user/bookings/$id'
      path: '/$id'
      fullPath: '/bookings/$id'
      preLoaderRoute: typeof UserBookingsIdRouteImport
      parentRoute: typeof UserBookingsRoute
    }
    '/admin/bookings/$id': {
      id: '/admin/bookings/$id'
      path: '/$id'
      fullPath: '/admin/bookings/$id'
      preLoaderRoute: typeof AdminBookingsIdRouteImport
      parentRoute: typeof AdminBookingsRoute
    }
    '/events/$eventId/tickets': {
      id: '/events/$eventId/tickets'
      path: '/tickets'
      fullPath: '/events/$eventId/tickets'
      preLoaderRoute: typeof EventsEventIdTicketsRouteImport
      parentRoute: typeof EventsEventIdRoute
    }
    '/room-detail/$venueId/$roomId': {
      id: '/room-detail/$venueId/$roomId'
      path: '/room-detail/$venueId/$roomId'
      fullPath: '/room-detail/$venueId/$roomId'
      preLoaderRoute: typeof RoomDetailVenueIdRoomIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminBookingsRouteChildren {
  AdminBookingsIdRoute: typeof AdminBookingsIdRoute
}

const AdminBookingsRouteChildren: AdminBookingsRouteChildren = {
  AdminBookingsIdRoute: AdminBookingsIdRoute,
}

const AdminBookingsRouteWithChildren = AdminBookingsRoute._addFileChildren(
  AdminBookingsRouteChildren,
)

interface AdminRouteChildren {
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminBookingsRoute: typeof AdminBookingsRouteWithChildren
  AdminCalendarRoute: typeof AdminCalendarRoute
  AdminCheckInRoute: typeof AdminCheckInRoute
  AdminCustomersRoute: typeof AdminCustomersRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminEarningsRoute: typeof AdminEarningsRoute
  AdminEscrowsRoute: typeof AdminEscrowsRoute
  AdminEventsRoute: typeof AdminEventsRoute
  AdminListingsRoute: typeof AdminListingsRoute
  AdminManagerAnalyticsRoute: typeof AdminManagerAnalyticsRoute
  AdminModeratorRoute: typeof AdminModeratorRoute
  AdminMyBookingsRoute: typeof AdminMyBookingsRoute
  AdminPendingPayoutsRoute: typeof AdminPendingPayoutsRoute
  AdminProfileRoute: typeof AdminProfileRoute
  AdminRefundsRoute: typeof AdminRefundsRoute
  AdminReviewsRoute: typeof AdminReviewsRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminRoomsRoute: typeof AdminRoomsRoute
  AdminScanTicketsRoute: typeof AdminScanTicketsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStaffRoute: typeof AdminStaffRoute
  AdminSupportRoute: typeof AdminSupportRoute
  AdminVenueManagersRoute: typeof AdminVenueManagersRoute
  AdminVenuesRoute: typeof AdminVenuesRoute
  AdminWalletRoute: typeof AdminWalletRoute
  AdminWithdrawalsRoute: typeof AdminWithdrawalsRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminBookingsRoute: AdminBookingsRouteWithChildren,
  AdminCalendarRoute: AdminCalendarRoute,
  AdminCheckInRoute: AdminCheckInRoute,
  AdminCustomersRoute: AdminCustomersRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminEarningsRoute: AdminEarningsRoute,
  AdminEscrowsRoute: AdminEscrowsRoute,
  AdminEventsRoute: AdminEventsRoute,
  AdminListingsRoute: AdminListingsRoute,
  AdminManagerAnalyticsRoute: AdminManagerAnalyticsRoute,
  AdminModeratorRoute: AdminModeratorRoute,
  AdminMyBookingsRoute: AdminMyBookingsRoute,
  AdminPendingPayoutsRoute: AdminPendingPayoutsRoute,
  AdminProfileRoute: AdminProfileRoute,
  AdminRefundsRoute: AdminRefundsRoute,
  AdminReviewsRoute: AdminReviewsRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminRoomsRoute: AdminRoomsRoute,
  AdminScanTicketsRoute: AdminScanTicketsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStaffRoute: AdminStaffRoute,
  AdminSupportRoute: AdminSupportRoute,
  AdminVenueManagersRoute: AdminVenueManagersRoute,
  AdminVenuesRoute: AdminVenuesRoute,
  AdminWalletRoute: AdminWalletRoute,
  AdminWithdrawalsRoute: AdminWithdrawalsRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface DashboardRouteChildren {
  DashboardBookingsRoute: typeof DashboardBookingsRoute
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardWalletRoute: typeof DashboardWalletRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardBookingsRoute: DashboardBookingsRoute,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardWalletRoute: DashboardWalletRoute,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface EventsEventIdRouteChildren {
  EventsEventIdTicketsRoute: typeof EventsEventIdTicketsRoute
}

const EventsEventIdRouteChildren: EventsEventIdRouteChildren = {
  EventsEventIdTicketsRoute: EventsEventIdTicketsRoute,
}

const EventsEventIdRouteWithChildren = EventsEventIdRoute._addFileChildren(
  EventsEventIdRouteChildren,
)

interface EventsRouteChildren {
  EventsEventIdRoute: typeof EventsEventIdRouteWithChildren
  EventsCreateRoute: typeof EventsCreateRoute
  EventsIndexRoute: typeof EventsIndexRoute
}

const EventsRouteChildren: EventsRouteChildren = {
  EventsEventIdRoute: EventsEventIdRouteWithChildren,
  EventsCreateRoute: EventsCreateRoute,
  EventsIndexRoute: EventsIndexRoute,
}

const EventsRouteWithChildren =
  EventsRoute._addFileChildren(EventsRouteChildren)

interface UserBookingsRouteChildren {
  UserBookingsIdRoute: typeof UserBookingsIdRoute
}

const UserBookingsRouteChildren: UserBookingsRouteChildren = {
  UserBookingsIdRoute: UserBookingsIdRoute,
}

const UserBookingsRouteWithChildren = UserBookingsRoute._addFileChildren(
  UserBookingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  BusinessSignupRoute: BusinessSignupRoute,
  BusinessTypeRoute: BusinessTypeRoute,
  DashboardRoute: DashboardRouteWithChildren,
  EventsRoute: EventsRouteWithChildren,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSignupRoute: AuthSignupRoute,
  CategoriesEventCentresRoute: CategoriesEventCentresRoute,
  CategoriesHotelsRoute: CategoriesHotelsRoute,
  CategoriesOpenSpacesRoute: CategoriesOpenSpacesRoute,
  HostListYourPropertyRoute: HostListYourPropertyRoute,
  HostMyVenuesRoute: HostMyVenuesRoute,
  InfoAboutRoute: InfoAboutRoute,
  InfoContactRoute: InfoContactRoute,
  UserBookingsRoute: UserBookingsRouteWithChildren,
  UserProfileRoute: UserProfileRoute,
  UserWalletRoute: UserWalletRoute,
  BookingVenueIdRoute: BookingVenueIdRoute,
  BookingSuccessRoute: BookingSuccessRoute,
  VenuesVenueIdRoute: VenuesVenueIdRoute,
  RoomDetailVenueIdRoomIdRoute: RoomDetailVenueIdRoomIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
